"use client";

import CookieConsent from "@/components/CookieConsent";
import AppContextProvider from "@/context/AppContext";
import { useAPI } from "@/lib/api";
import { Toaster } from "react-hot-toast";
import { SWRConfig } from "swr";

export default function Providers({ children }) {
  const api = useAPI("en");
  return (
    <AppContextProvider value={{ kind: "MICROSITE", locale: "en" }}>
      <SWRConfig
        value={{
          revalidateOnFocus: true,
          revalidateOnMount: true,
          refreshWhenHidden: false,
          fetcher: async (url) => await api.get(url),
        }}
      >
        <Toaster containerStyle={{ zIndex: 999999999 }} />
        {children}
        <CookieConsent autoEnabled autoShow={false} domain="" />
      </SWRConfig>
    </AppContextProvider>
  );
}
